// extracted by mini-css-extract-plugin
module.exports = {"main":"SpacingReverser_main__1nmet","panel":"SpacingReverser_panel__22_3q"};